import { FC } from "react";
import { PageTitle, PageLink } from "../../../../rbts/layout/core";
import { View } from "./components/View";

const widgetsBreadCrumbs: Array<PageLink> = [];

const DayCutPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>Cortes del día</PageTitle>
      <View />
    </>
  );
};

export { DayCutPage };
